module.exports = __webpack_public_path__ + "img/Gruppenführer.8c53bcb8.svg";